import axios from 'axios';
import {
  IDeleteLimitOrderPayload,
  ILimitOrder,
  ILimitOrderBody,
  ILimitOrdersResponse,
  IUpdateLimitOrderPayload,
} from '../interfaces/kattana';

export interface ILimitOrderApi {
  limitOrdersEndpoint: string;
  get: (
    wallet: string,
    authToken: string
  ) => Promise<ILimitOrdersResponse | null>;
  canCreate: (wallet: string, authToken: string) => Promise<any>;
  create: (payload: ILimitOrderBody, authToken: string) => Promise<any>;
  createGrid: (payload: ILimitOrderBody, authToken: string) => Promise<any>;
  createWhale: (payload: ILimitOrderBody, authToken: string) => Promise<any>;
  remove: (
    payload: IDeleteLimitOrderPayload,
    authToken: string
  ) => Promise<any>;
  update: (
    payload: IUpdateLimitOrderPayload,
    authToken: string
  ) => Promise<any>;
}

export class LimitOrderApi implements ILimitOrderApi {
  limitOrdersEndpoint: string;

  constructor(apiGateway: string) {
    if (!apiGateway) {
      apiGateway = 'https://api.kattana.trade';
    }

    this.limitOrdersEndpoint = `${apiGateway}/limit-orders`;
  }

  public get = async (
    wallet: string,
    authToken: string
  ): Promise<ILimitOrdersResponse | null> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      const res = await axios.get(
        `${this.limitOrdersEndpoint}/${wallet}`,
        config
      );
      return res.data;
    } catch (err) {
      console.warn(err);
      return null;
    }
  };

  public canCreate = async (
    wallet: string,
    authToken: string
  ): Promise<any> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      const res = await axios.get(
        `${this.limitOrdersEndpoint}/${wallet}/can-create`,
        config
      );
      return res.data;
    } catch (err) {
      console.warn(err);
      return null;
    }
  };

  public create = async (
    payload: ILimitOrderBody,
    authToken: string
  ): Promise<any> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      const res = await axios.post(
        `${this.limitOrdersEndpoint}`,
        payload,
        config
      );
      return res.data;
    } catch (err) {
      console.warn(err);
      return err;
    }
  };

  public createGrid = async (
    payload: ILimitOrderBody,
    authToken: string
  ): Promise<any> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      const res = await axios.post(
        `${this.limitOrdersEndpoint}/grid`,
        payload,
        config
      );
      return res.data;
    } catch (err) {
      console.warn(err);
      return err;
    }
  };

  public createWhale = async (
    payload: ILimitOrderBody,
    authToken: string
  ): Promise<any> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      const res = await axios.post(
        `${this.limitOrdersEndpoint}/whale-limit`,
        payload,
        config
      );
      return res.data;
    } catch (err) {
      console.warn(err);
      return err;
    }
  };

  public remove = async (
    payload: IDeleteLimitOrderPayload,
    authToken: string
  ): Promise<any> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      const res = await axios.delete(
        `${this.limitOrdersEndpoint}/${payload.uuid}/${payload.wallet}`,
        config
      );
      return res.data;
    } catch (err) {
      console.warn(err);
      return null;
    }
  };

  public update = async (
    payload: IUpdateLimitOrderPayload,
    authToken: string
  ): Promise<any> => {
    try {
      const config = {
        headers: { Authorization: `Bearer ${authToken}` },
      };
      const res = await axios.put(
        `${this.limitOrdersEndpoint}/${payload.uuid}/${payload.wallet}`,
        payload,
        config
      );
      return res.data;
    } catch (err) {
      console.warn(err);
      return null;
    }
  };
}
